import { createSelector } from 'reselect'

export const getVehicleParts = createSelector(
  state => state && state.vehicleParts && state.vehicleParts.list && Array.isArray(state.vehicleParts.list.products) ? state.vehicleParts.list.products : [],
  products => products
)
